import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ServicePageLayout from "../components/ServicePageLayout";
import EventShowCard from "../components/EventShowCard";
import ConfirmSheet from "../components/ConfirmSheet";
import { useGuestSession } from "contexts/GuestSessionContext";
import { withGuestSearch } from "data/guestPortalDefaults";
import { LUXURY } from "data/guestLuxuryTheme";

const EventsPage = () => {
  const navigate = useNavigate();
  const { portalConfig, createRequest, guestSearch } = useGuestSession();
  const events = portalConfig.events || [];
  const [confirm, setConfirm] = useState(null);

  const reserve = (event) => {
    createRequest({
      type: "events",
      title: event.cta || "Reserve event",
      details: event.title,
      note: [event.when, event.where, event.price].filter(Boolean).join(" · "),
    });
    setConfirm(event);
  };

  return (
    <ServicePageLayout
      title="Events"
      subtitle="Tonight and this week — tap a card to reserve."
      illustration="events"
    >
      {events.length === 0 ? (
        <Box
          sx={{
            p: 3,
            borderRadius: "18px",
            bgcolor: LUXURY.card,
            border: `1px solid ${LUXURY.cardBorder}`,
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontFamily: LUXURY.displayFont, fontWeight: 600, fontSize: "1.3rem", color: LUXURY.ink }}>
            Nothing scheduled
          </Typography>
          <Typography sx={{ mt: 0.6, color: LUXURY.muted, fontSize: "0.88rem", lineHeight: 1.5 }}>
            Ask the team what’s on this week — or order from the menu while you wait.
          </Typography>
        </Box>
      ) : (
        <Stack spacing={1.6}>
          {events.map((event) =>
            event.image ? (
              <EventShowCard key={event.id} event={event} onClick={() => reserve(event)} />
            ) : (
              <Box
                key={event.id}
                sx={{
                  p: 1.8,
                  borderRadius: "20px",
                  bgcolor: LUXURY.card,
                  boxShadow: LUXURY.cardShadow,
                }}
              >
                <Typography sx={{ fontFamily: LUXURY.displayFont, fontWeight: 600, fontSize: "1.28rem", color: LUXURY.ink }}>
                  {event.title}
                </Typography>
                <Typography sx={{ mt: 0.4, fontSize: "0.8rem", color: LUXURY.muted }}>
                  {[event.when, event.where].filter(Boolean).join(" · ")}
                </Typography>
              </Box>
            )
          )}
        </Stack>
      )}

      <ConfirmSheet
        open={Boolean(confirm)}
        onClose={() => setConfirm(null)}
        onViewRequests={() => navigate(withGuestSearch("/guest/requests", guestSearch))}
        title="We’ll hold a place"
        message={
          confirm
            ? `${confirm.title} — ${[confirm.when, confirm.where].filter(Boolean).join(" · ")}. The team will confirm shortly.`
            : ""
        }
      />
    </ServicePageLayout>
  );
};

export default EventsPage;
